export default __webpack_public_path__ + "static/media/Liver.f5e2bede.svg";